var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1662_40942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1662_40942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7C10.5 6.45 10.6958 5.97917 11.0875 5.5875C11.4792 5.19583 11.95 5 12.5 5C13.05 5 13.5208 5.19583 13.9125 5.5875C14.3042 5.97917 14.5 6.45 14.5 7C14.5 7.55 14.3042 8.02083 13.9125 8.4125C13.5208 8.80417 13.05 9 12.5 9C11.95 9 11.4792 8.80417 11.0875 8.4125C10.6958 8.02083 10.5 7.55 10.5 7ZM12.5 24L8 19.5L9.5 17.5L8 15.5L9.5 13.375V12.2C8.6 11.6667 7.875 10.9458 7.325 10.0375C6.775 9.12917 6.5 8.11667 6.5 7C6.5 5.33333 7.08333 3.91667 8.25 2.75C9.41667 1.58333 10.8333 1 12.5 1C14.1667 1 15.5833 1.58333 16.75 2.75C17.9167 3.91667 18.5 5.33333 18.5 7C18.5 8.11667 18.225 9.12917 17.675 10.0375C17.125 10.9458 16.4 11.6667 15.5 12.2V21L12.5 24ZM8.5 7C8.5 7.93333 8.78333 8.75417 9.35 9.4625C9.91667 10.1708 10.6333 10.6417 11.5 10.875V14L10.475 15.45L12 17.5L10.625 19.275L12.5 21.15L13.5 20.15V10.875C14.3667 10.6417 15.0833 10.1708 15.65 9.4625C16.2167 8.75417 16.5 7.93333 16.5 7C16.5 5.9 16.1083 4.95833 15.325 4.175C14.5417 3.39167 13.6 3 12.5 3C11.4 3 10.4583 3.39167 9.675 4.175C8.89167 4.95833 8.5 5.9 8.5 7Z",
    fill: "#3F25AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyVertical);
export default __webpack_public_path__ + "static/media/key_vertical.9b1c48c9f562d8c300e56a1ab262561c.svg";
export { ForwardRef as ReactComponent };